export default function Hero() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-16">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/60"></div>
        <div className="absolute top-0 right-0 w-[600px] h-[600px] md:w-[800px] md:h-[800px] rounded-full bg-primary-100/30 blur-3xl -translate-y-1/4 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] md:w-[700px] md:h-[700px] rounded-full bg-accent-100/20 blur-3xl translate-y-1/3 -translate-x-1/4"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="w-full max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium tracking-wide mb-4 md:mb-5">
              韩漫 · 日漫 · 国漫
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-3 md:mb-4">
              虫虫动漫
              <span className="block text-xl sm:text-2xl md:text-3xl lg:text-4xl font-normal text-foreground-600 mt-2">
                免费在线阅读平台
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-500 leading-relaxed mb-2 md:mb-3 font-body">
              下拉式滚动浏览，沉浸式畅快追漫
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6 md:mb-7">
              虫虫动漫按韩漫、日漫、国漫三大品类精心整理漫画资源，为你提供分类清晰、更新及时的免费在线阅读体验。无论你是热衷热血战斗、甜蜜恋爱还是悬疑推理，这里都有属于你的漫画世界。每周持续上新，热门连载同步追踪，下拉式滚动浏览让阅读一气呵成。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7 md:mb-8">
              <div className="flex flex-col items-center">
                <span className="text-xl md:text-2xl font-bold text-primary-500 font-heading">2000+</span>
                <span className="text-xs text-foreground-500 mt-0.5">精选漫画</span>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex flex-col items-center">
                <span className="text-xl md:text-2xl font-bold text-accent-500 font-heading">每日更新</span>
                <span className="text-xs text-foreground-500 mt-0.5">同步连载</span>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex flex-col items-center">
                <span className="text-xl md:text-2xl font-bold text-secondary-500 font-heading">500万+</span>
                <span className="text-xs text-foreground-500 mt-0.5">漫画爱好者</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); scrollTo('#ranking'); }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                探索热门榜单
              </a>
              <a
                href="#topics"
                onClick={(e) => { e.preventDefault(); scrollTo('#topics'); }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 font-medium text-sm rounded-lg hover:bg-background-100 hover:border-background-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                按话题发现
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-sm sm:max-w-md lg:max-w-lg xl:max-w-xl">
            <div className="relative aspect-[4/5] sm:aspect-[4/5] lg:aspect-[3/4] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20cozy%20reading%20scene%20with%20manga%20books%20and%20a%20digital%20tablet%20displaying%20colorful%20comic%20pages%20in%20Korean%20Japanese%20and%20Chinese%20styles%2C%20soft%20warm%20lighting%20from%20a%20desk%20lamp%2C%20artistic%20illustration%20style%20with%20rich%20orange%20and%20amber%20tones%2C%20cozy%20atmosphere%2C%20modern%20minimal%20desk%20setup%20with%20plants%2C%20editorial%20quality%2C%20harmonious%20composition&width=800&height=1000&seq=hero-manga-01&orientation=portrait"
                alt="虫虫动漫阅读场景 - 韩漫日漫国漫在线阅读"
                className="w-full h-full object-cover"
                onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}